import React from "react";
import styled, { css } from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import { H3 } from "BaseComponents/Text";
import { HeaderLinkStyle as HeaderLink } from "../../../BaseComponents/Link/BaseLink";

export const CardWrapper = styled.a.attrs(
	({
		theme,
		href
	}) =>({
		white: theme.colors.white,
		radius: theme.border.radius,
		primary: theme.colors.primary,
		haveLink: href !== undefined
	})
)`
	border: 1px solid #d0d0d0;
	background-color: ${({ white }) => white};
	border-radius: ${({ radius }) => radius};
	padding: 1rem;
	display: flex;
	flex-direction: column;
	width: auto;
	align-items: center;
	margin: 0.5rem;
	outline: none;
	transition: all 0.2s ease;
	cursor: ${({ haveLink }) => haveLink ? 'pointer': 'arrow'};
	min-height: 220px;
	${H3} {
		border-bottom: 2px solid transparent;
		transition: 0.2s ease;
	}

	${media.greaterThan(breakpoints.mobile)`
        margin: 1rem;
        min-height: auto;
        flex-basis: calc(47% - 4rem);
        flex-grow: 1;
    `}

	${media.greaterThan(breakpoints.ipad)`
    flex-basis: calc(25% - 4rem);
	&:first-of-type {
		margin-left: 0;
	}
  `}
    
  &:hover, &:focus {
		border-color: ${({ primary, haveLink }) => haveLink ? primary: 'none' };
		
		${H3} {
			transition: 0.2s ease;
			border-color: ${({ haveLink }) => haveLink ? 'black': 'transparent'};
		}
	}
`;

export const CardWrapperDiv = styled.div.attrs(
	({
		 theme,
	 }) =>({
		white: theme.colors.white,
		radius: theme.border.radius,
	})
)`
	border: 1px solid #d0d0d0;
	background-color: ${({ white }) => white};
	border-radius: ${({ radius }) => radius};
	padding: 1rem;
	display: flex;
	flex-direction: column;
	width: auto;
	align-items: center;
	margin: 0.5rem;
	outline: none;
	transition: all 0.2s ease;
	cursor: arrow;
	min-height: 220px;
	${H3} {
		border-bottom: 2px solid transparent;
		transition: 0.2s ease;
	}

	${media.greaterThan(breakpoints.mobile)`
        margin: 1rem;
        min-height: auto;
        flex-basis: calc(47% - 4rem);
        flex-grow: 1;
    `}

	${media.greaterThan(breakpoints.ipad)`
    flex-basis: calc(25% - 4rem);
	&:first-of-type {
		margin-left: 0;
	}
  `}
    
  &:hover, &:focus {
		border-color: none;
		
		${H3} {
			transition: 0.2s ease;
			border-color: transparent;
		}
	}
`;
